import { Button, Result } from 'antd';
import { useHistory } from 'react-router-dom';
import './styles.less';

interface AccessUpgradeProps {
  isHome?: boolean;
}

export default function AccessUpgrade({ isHome }: AccessUpgradeProps) {
  const history = useHistory();
  return (
    <Result
      status="403"
      title={<strong>Faça Upgrade!</strong>}
      subTitle="Seu combo atual não tem acesso a esta funcionalidade, entre em contato com o suporte para fazer upgrade."
      extra={
        !isHome && (
          <Button onClick={() => history.push('/app/dashboard')} type="primary">
            Ir para o ínicio
          </Button>
        )
      }
    />
  );
}
